// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CreateAccountSignInStyles } from "@gcg/App/Widgets/CreateAccount/CreateAccountSignIn";
import { screen } from "@gcg/XDL/Helpers";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

CreateAccountSignInStyles.centeringWrapper = {
    css: css`
        display: flex;
        height: 300px;
        justify-content: center;
        align-items: center;
    `,
};
CreateAccountSignInStyles.step1Wrapper = {};
CreateAccountSignInStyles.tooltipWrapper = {};
CreateAccountSignInStyles.createNewAccountButton = { variant: "primary" };
CreateAccountSignInStyles.infoTipIconStyle = {
    css: css`
        margin-left: 5px;
    `,
};
CreateAccountSignInStyles.nextButtonWrapperStyles = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: space-between;
                    `,
                    null,
                    null,
                    css`
                        flex-direction: row;
                        justify-content: space-between;
                    `,
                ],
                "min",
            )}
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        button {
                            width: 100%;
                        }
                    `,
                ],
                "max",
            )}
    `,
};
CreateAccountSignInStyles.optionWrapper = {
    css: css`
        display: flex;
        align-items: flex-start;

        input + label {
            margin-right: 15px !important;
        }

        ${screen("lte", "xs")`
            justify-content: space-between;
                    
            input + label {
                margin-right: 0 !important;
                max-width: 90%;
            }
        `}
    `,
};
CreateAccountSignInStyles.radioGroup = {
    css: css`
        > div {
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    `,
};
CreateAccountSignInStyles.checkoutAsGuestButton = {
    variant: "tertiary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        margin-bottom: 1rem;
                    `,
                ],
                "max",
            )}
    `,
};